import {frontBaseUrl, frontEndType} from "../../build_constants.ts";
import {FRONT_END_TYPE} from "../../constants.ts";
import {Link} from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function LoginBlock() {
    const { t } = useTranslation("ui");

    if (frontEndType == FRONT_END_TYPE.XSLAB) {
        return (
            <div className="row mt-3 mb-5">
                <p className="col-md-6 txt-do-not-have-an-account">          {t("signUp.alreadySignedUp")}</p>
                <Link className="col-md-6 fw-medium text-primary anchor-login" to={`${frontBaseUrl}/login`}>{t("login.login")}</Link>
            </div>
        );
    }

    return (<></>);
}